import React, { useMemo } from "react";
import classnames from "classnames";
import { Text, Tooltip } from "components/commons";
import styles from "./field.module.scss";
import { v4 as uuidv4 } from "uuid";

const Field = ({
  width,
  children,
  className,
  label,
  filterLabel,
  required = false,
  message,
  customLabel,
  customMessage,
  noLabel = false,
  errorClassName,
  error,
  labelSuffix,
  tooltipLabel,
}) => {
  const labelDisplay = useMemo(() => {
    if (customLabel) return customLabel;
    if (noLabel) return null;
    if (label) {
      return (
        <Text label className="break-all">
          {label}
          {required && <span className="text-red"> *</span>}
        </Text>
      );
    } else if (filterLabel) {
      return (
        <Text color="text-black-light" strong>
          {filterLabel}
          {required && <span className="text-red"> *</span>}
        </Text>
      );
    }
  }, [label, filterLabel, customLabel, noLabel, required]);

  return (
    <div className={classnames(`${width ? `${width}` : `w-full`}`, className, styles.field)}>
      {(labelDisplay || labelSuffix) && (
        <div className="mb-xs flex justify-between items-center">
          <Tooltip
            title={tooltipLabel}
            key={uuidv4()}
            placement="topLeft"
            className="cursor-pointer"
          >
            <div>{labelDisplay}</div>
          </Tooltip>
          {labelSuffix}
        </div>
      )}
      <div>{children}</div>
      {customMessage || message ? (
        <div className={errorClassName || "pn-error mt-xs"}>
          {customMessage || (
            <Text error={error} color={error ? "text-red" : "text-black"}>
              {message}
            </Text>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default Field;
